import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to the top (or to the hash target) whenever the route changes.
 * Renders nothing. Must be used inside a Router.
 */
const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, '');
      const el = id ? document.getElementById(id) : null;
      if (el) {
        requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
